import { render, staticRenderFns } from "./dialog5.vue?vue&type=template&id=7cfdf12e&scoped=true&"
import script from "./dialog5.vue?vue&type=script&lang=js&"
export * from "./dialog5.vue?vue&type=script&lang=js&"
import style0 from "./dialog5.vue?vue&type=style&index=0&id=7cfdf12e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfdf12e",
  null
  
)

export default component.exports